// basit helper
const DIAL_CODE = {
  PL:'48', DE:'49', AT:'43', CZ:'420', SK:'421', HU:'36',
  TR:'90', US:'1', GB:'44', FR:'33', ES:'34', IT:'39',
  NL:'31', BE:'32', PT:'351', SE:'46', NO:'47', DK:'45',
  FI:'358', CH:'41', IE:'353', RO:'40', BG:'359', HR:'385', SI:'386'
};

export function normalizePhoneWithCountry(raw, iso2, fallbackIso2) {
  if (!raw) return '';
  const trimmed = String(raw).trim();

  // zaten + ile başlıyorsa
  if (trimmed.startsWith('+')) {
    return '+' + trimmed.replace(/[^\d]/g, '');
  }

  const iso = (iso2 || fallbackIso2 || '').toUpperCase();
  const dial = DIAL_CODE[iso];

  const local = trimmed.replace(/[^\d]/g, '').replace(/^0+/, '');
  return dial ? `+${dial}${local}` : local;
}
